var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_576978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 11.4L6 9.59998V22.9002C6 23.5076 6.49239 24 7.0998 24H24.7002C25.3076 24 25.8 23.5076 25.8 22.9002V18L16.2 11.4Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 0H7.0998C6.49239 0 6 0.492394 6 1.0998V6L16.2 12L21.6 13.8L25.8 12V6L16.2 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6H16.2V12H6V6Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.3002 4.79999H6V19.8H13.3002C13.9068 19.798 14.398 19.3068 14.4 18.7002V5.89978C14.398 5.2932 13.9068 4.80196 13.3002 4.79999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7002 5.40002H6V20.4H12.7002C13.3068 20.3981 13.798 19.9068 13.8 19.3002V6.49982C13.798 5.89324 13.3068 5.402 12.7002 5.40002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7002 5.40002H6V19.2H12.7002C13.3068 19.1981 13.798 18.7068 13.8 18.1002V6.49982C13.798 5.89324 13.3068 5.402 12.7002 5.40002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.1002 5.40002H6V19.2H12.1002C12.7068 19.1981 13.198 18.7068 13.2 18.1002V6.49982C13.198 5.89324 12.7068 5.402 12.1002 5.40002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0998 5.40002H12.1002C12.7076 5.40002 13.2 5.89242 13.2 6.49982V17.5002C13.2 18.1076 12.7076 18.6 12.1002 18.6H1.0998C0.492394 18.6 0 18.1076 0 17.5002V6.49982C0 5.89242 0.492394 5.40002 1.0998 5.40002Z",
    fill: "url(#paint0_linear_1168_576978)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40625 15.5748L5.71985 11.9898L3.60005 8.42462H5.30525L6.46205 10.7046C6.56885 10.9212 6.64205 11.082 6.68165 11.1882H6.69665C6.77265 11.0154 6.85265 10.8476 6.93665 10.6848L8.17325 8.42583H9.73864L7.56484 11.97L9.79386 15.5748H8.12826L6.79205 13.0722C6.72911 12.9657 6.6757 12.8539 6.63246 12.738H6.61266C6.57352 12.8516 6.52159 12.9603 6.45786 13.062L5.08206 15.5748H3.40625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7004 0H16.2002V6H25.8002V1.0998C25.8002 0.492394 25.3078 0 24.7004 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 12H25.8002V18H16.2002V12Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_576978",
    x1: 2.29311,
    y1: 4.54066,
    x2: 10.9069,
    y2: 19.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_576978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d5af0ffe180643dcacaae489f96b2cb6.svg";
export { ForwardRef as ReactComponent };